/*
  GOPSHOP Arcade – kompaktes Spiele-Karussell + Pausieren der animierten Vorschauen außerhalb des Bildschirms.
  Karussell: wischbar (native Scroll-Snap), Punkte, Pfeile, Auto-Wechsel; pausiert bei Berührung/Hover/Fokus,
  wenn nicht sichtbar oder bei „Bewegung reduzieren“.
*/
(function () {
  if (window.GopArcade) return;
  window.GopArcade = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  // Vorschauen nur animieren, wenn sichtbar
  function watchPreviews(scope) {
    var list = (scope || document).querySelectorAll('[data-gpv]');
    if (!hasIO) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-off', !e.isIntersecting); });
    }, { rootMargin: '80px' });
    list.forEach(function (el) {
      if (el.__gpv) return;
      el.__gpv = true;
      el.classList.add('is-off');
      io.observe(el);
    });
  }

  function Carousel(root) {
    var track = root.querySelector('[data-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var n = slides.length;
    var ms = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var index = 0;
    var timer = null;
    var visible = false;
    var holds = { hover: false, focus: false, touch: false };
    var userStopped = false;

    root.style.setProperty('--gop-arcc-ms', ms + 'ms');
    if (reduce || n < 2) root.classList.add('is-static');

    function setActive(i) {
      index = i;
      dots.forEach(function (d, k) {
        if (k === i) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      slides.forEach(function (s, k) {
        s.toggleAttribute('inert', k !== i);
        var gpv = s.querySelector('[data-gpv]');
        if (gpv) gpv.classList.toggle('is-hidden-slide', k !== i);
      });
      // Fortschrittsbalken neu starten
      var cur = dots[i] && dots[i].querySelector('i');
      if (cur) { cur.style.display = 'none'; void cur.offsetWidth; cur.style.display = ''; }
    }

    function go(i, fromUser) {
      i = (i + n) % n;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      setActive(i);
      if (fromUser) userStopped = true;
      schedule();
    }

    function paused() {
      return reduce || n < 2 || !visible || userStopped || holds.hover || holds.focus || holds.touch || document.hidden;
    }

    function schedule() {
      clearTimeout(timer);
      root.classList.toggle('is-paused', paused());
      if (paused()) return;
      timer = setTimeout(function () { go(index + 1); }, ms);
    }

    // Wischen: aktiven Punkt aus der Scroll-Position ableiten
    var raf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== index && i >= 0 && i < n) { setActive(i); schedule(); }
      });
    }, { passive: true });

    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-dot'), 10), true); });
    });
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1, true); });
    if (next) next.addEventListener('click', function () { go(index + 1, true); });

    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { holds.hover = true; schedule(); } });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { holds.hover = false; schedule(); } });
    root.addEventListener('focusin', function () { holds.focus = true; schedule(); });
    root.addEventListener('focusout', function () { holds.focus = root.contains(document.activeElement); schedule(); });
    // Nach Wischen/Tippen stoppt der Auto-Wechsel (Nutzer hat die Kontrolle)
    track.addEventListener('touchstart', function () { holds.touch = true; userStopped = true; schedule(); }, { passive: true });
    track.addEventListener('touchend', function () { holds.touch = false; schedule(); }, { passive: true });
    document.addEventListener('visibilitychange', schedule);

    if (hasIO) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        schedule();
      }, { threshold: 0.4 }).observe(root);
    } else {
      visible = true;
    }

    setActive(0);
    schedule();
  }


  // Laser-Jagd-Vorschau: Laserpunkt springt wild umher, Gopa rast hinterher und kracht gegen die Ränder
  function LaserPreview(el) {
    var chase = el.querySelector('.gpv__chase');
    var flip = el.querySelector('.gpv__flip');
    var bang = el.querySelector('.gpv__bang');
    var lines = el.querySelectorAll('.gpv__beam line');
    var dot = el.querySelector('.gpv__dot');
    if (!chase || !flip || !dot || !lines.length) return;
    el.appendChild(dot); // Punkt unabhängig von Gopa bewegen
    el.classList.add('is-js');
    var W = 1, H = 1, gw = 0, gh = 0;
    var d = { x: 0.7, y: 0.3, tx: 0.7, ty: 0.3, next: 0 };
    var g = { x: 0.2, y: 0.5, vx: 0, vy: 0, face: 1 };
    var last = 0, raf = 0, cool = 0;
    function size() {
      W = el.clientWidth || 1; H = el.clientHeight || 1;
      gw = chase.offsetWidth || W * 0.22; gh = chase.offsetHeight || gw;
    }
    function pick(t) {
      // oft an den Rand, damit Gopa dagegen kracht
      var edge = Math.random() < 0.55;
      d.tx = edge ? (Math.random() < 0.5 ? 0.02 : 0.98) : 0.08 + Math.random() * 0.84;
      d.ty = edge && Math.random() < 0.5 ? (Math.random() < 0.5 ? 0.04 : 0.96) : 0.1 + Math.random() * 0.8;
      d.next = t + 380 + Math.random() * 700;
    }
    function hit(x, y) {
      if (cool > 0) return;
      cool = 0.35;
      bang.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      bang.classList.remove('is-hit'); void bang.offsetWidth; bang.classList.add('is-hit');
      el.classList.remove('is-shake'); void el.offsetWidth; el.classList.add('is-shake');
    }
    function frame(t) {
      raf = 0;
      if (el.classList.contains('is-off') || document.hidden) { last = 0; return; }
      var dt = last ? Math.min(0.05, (t - last) / 1000) : 0.016;
      last = t;
      if (t > d.next) pick(t);
      d.x += (d.tx - d.x) * Math.min(1, dt * 14);
      d.y += (d.ty - d.y) * Math.min(1, dt * 14);
      // Gopa: sehr schnell Richtung Punkt beschleunigen, etwas träge (schießt übers Ziel hinaus)
      var ax = (d.x - g.x) * 60, ay = (d.y - g.y) * 60;
      g.vx = (g.vx + ax * dt) * Math.pow(0.12, dt);
      g.vy = (g.vy + ay * dt) * Math.pow(0.12, dt);
      g.x += g.vx * dt; g.y += g.vy * dt;
      var mx = (gw / 2) / W, my = (gh / 2) / H;
      cool = Math.max(0, cool - dt);
      if (g.x < mx) { g.x = mx; if (g.vx < -0.9) hit(0, g.y * H); g.vx = -g.vx * 0.45; }
      if (g.x > 1 - mx) { g.x = 1 - mx; if (g.vx > 0.9) hit(W, g.y * H); g.vx = -g.vx * 0.45; }
      if (g.y < my) { g.y = my; if (g.vy < -0.9) hit(g.x * W, 0); g.vy = -g.vy * 0.45; }
      if (g.y > 1 - my) { g.y = 1 - my; if (g.vy > 0.9) hit(g.x * W, H); g.vy = -g.vy * 0.45; }
      if (Math.abs(g.vx) > 0.15) g.face = g.vx > 0 ? 1 : -1;
      var tilt = Math.max(-18, Math.min(18, g.vx * 9));
      chase.style.transform = 'translate(' + (g.x * W - gw / 2) + 'px,' + (g.y * H - gh / 2) + 'px) rotate(' + tilt + 'deg)';
      flip.style.transform = 'scaleX(' + g.face + ')';
      var px = d.x * W, py = d.y * H;
      dot.style.transform = 'translate(' + (px - dot.offsetWidth / 2) + 'px,' + (py - dot.offsetHeight / 2) + 'px)';
      for (var i = 0; i < lines.length; i++) {
        lines[i].setAttribute('x2', (d.x * 100).toFixed(2));
        lines[i].setAttribute('y2', (d.y * 100).toFixed(2));
      }
      raf = requestAnimationFrame(frame);
    }
    function wake() { if (!raf) raf = requestAnimationFrame(frame); }
    size();
    window.addEventListener('resize', size);
    new MutationObserver(function () { size(); wake(); }).observe(el, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('visibilitychange', wake);
    wake();
  }

  function initLaser(scope) {
    if (reduce) return;
    (scope || document).querySelectorAll('.gpv--laser[data-gpv]').forEach(function (el) {
      if (el.__laser) return;
      el.__laser = true;
      LaserPreview(el);
    });
  }

  function init(scope) {
    watchPreviews(scope);
    initLaser(scope);
    (scope || document).querySelectorAll('[data-gop-arcc]').forEach(function (el) {
      if (el.__arcc) return;
      el.__arcc = true;
      Carousel(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
